import React, { useMemo } from "react";
import { PeopleData } from "./people.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers, IconAndTitle } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { Icon, ThemedIcon } from "@me8eon/icons";
import { PhotoDisplay } from "./photo.display";
//@ts-ignore
import icon from "./people.svg"

export const PeopleDisplay: DisplayData<PeopleData> =
    ({ rootId, id, data }: DisplayDataProps<PeopleData>) => {
        const { H3, Url, Text: JustText } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const resource = data.resource;
        if (!resource) {
            console.log('PeopleDisplay: no resource', data);
        }
        const { displayName,
            userPrincipalName,
            jobTitle,
            companyName,
            department,
            officeLocation,
            phones,
            imAddress
        } = resource;
        const photoName = displayName.split(", ").map((name) => name.charAt(0)).join(" ");
        // const KID = userPrincipalName.split("@")[0];
        const justEmail = imAddress ? imAddress.split(":")[1] : userPrincipalName;

        return <DataLayout rootId={newRootId} className="people-data" layout={[2]} >
            <div style={{ display: "flex", gap: "10px" }}>
                <PhotoDisplay photoName={photoName} height="100px" width="100px" />
                <div>
                    <H3 rootId={newRootId} attribute={translateLabelForData("name")} value={`${displayName}`} />
                    <JustText rootId={newRootId} attribute={"jobTitle"} value={jobTitle} />
                    {officeLocation && <JustText rootId={newRootId} attribute={"userPrincipalName"} value={userPrincipalName} />}
                    {companyName && <Text rootId={newRootId} attribute={translateLabelForData("company")} value={companyName} />}
                    {department && <Text rootId={newRootId} attribute={translateLabelForData("department")} value={department} />}
                </div>
            </div>
            <div>
                <Url
                    icon={() => <Icon
                        name="outlook"
                    />}
                    rootId={id} attribute={translateLabelForData('url')}
                    label={justEmail}
                    value={`mailto:${justEmail}`}
                />
                <Url
                    icon={() => <Icon
                        name="teams"
                    />}
                    rootId={id} attribute={translateLabelForData('url')}
                    label={justEmail}
                    value={`https://teams.microsoft.com/l/chat/0/0?users=${justEmail}`}
                />
                {phones && phones.map((phone) => {
                    return (
                        <Url
                            key={`${phone.type} ${phone.number}`}
                            icon={() => <ThemedIcon
                                size="normal"
                                name={phone.type === "mobile" ? "smartphone" : "toolkit"}
                            />}
                            rootId={id} attribute={translateLabelForData('url')}
                            label={phone.number}
                            value={`tel:${phone.number}`}
                        />
                    )
                })}
            </div>
        </DataLayout>;
    };

export const OneLinePeopleDisplay: DisplayData<PeopleData> =
    ({ data, listItemClicked }: DisplayDataProps<PeopleData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl: IconAndTitle = useMemo(() =>
        ({
            title: `${data.resource.displayName}`,
            icon: icon,
            onClick: () => { listItemClicked && listItemClicked(`${data.resource.displayName}`); },
        }), [data]);
        return (
            <SearchListItem key={data.resource.displayName} rootId={data.resource.displayName} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
        );
    };

export const SimplePeopleWidget: DisplayDataWidget<PeopleData> =
    SimpleWidget(
        [],
        [],
        []);

